import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormatService } from '../../services/format/format.service';
import { StorageService } from '../../services/storage/storage.service';
import { AccountService } from '../../services/account/account.service';

@Component({
  selector: 'app-enter-instagram-complete',
  standalone: true,
  imports: [],
  templateUrl: './enter-instagram-complete.component.html',
  styleUrl: './enter-instagram-complete.component.scss'
})
export class EnterInstagramCompleteComponent {

  accountService: AccountService = inject(AccountService);
  formatService: FormatService = inject(FormatService);
  storageService: StorageService = inject(StorageService);
  router: Router = inject(Router);
  instagramAccount: any | undefined;  

  ngOnInit() {
    console.log('Enter Instagram complete ---->');
    console.log('Enter Instagram account: ', this.accountService.enterInstagram);

    this.instagramAccount = this.accountService.enterInstagram;
  }

  exitBrowser() {
    console.log('Exit browser');
    window.close();
  }

  connectAnotherAccount() {
    console.log('Connect another account');
    const businessId = this.storageService.get('businessId');
    const externalId = this.storageService.get('externalId');
    this.router.navigate([`/connect/${externalId}/${businessId}`]);
  }
}
